import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, Platform } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/HttpProvider'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toArray';
import { CallNumber } from '@ionic-native/call-number';
import { EmailComposer } from '@ionic-native/email-composer';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  Marker
} from '@ionic-native/google-maps';


@Component({
  selector: 'page-event',
  templateUrl: 'event.html',
  providers: [HttpProvider]
})
export class EventPage {
  platformList: string = '';
  isApp: boolean = true;
  items: any;

  constructor(public navCtrl: NavController, private httpProvider: HttpProvider, private platform: Platform, private googleMaps: GoogleMaps,public callNumber: CallNumber,private emailComposer: EmailComposer, private inAppBrowser:InAppBrowser) {
    let platforms = this.platform.platforms();

    this.platformList = platforms.join(', ');

    if (this.platform.is('core') || this.platform.is('mobileweb')) {
      this.isApp = false;
    }
    this.getdata();
  }

  getdata() {
    this.httpProvider.getJsonData('places')
      .subscribe(
        result => {
          this.items = result;
          console.log("Success : " + result[0]['images'][0]['file']);
          this.items.forEach(element => {
            if (this.isApp) {
              //this.loadNativeMap(element.locationLong, element.locationLat, element.Id);
            }
            else {
              //this.loadHtmlMap(element.locationLong, element.locationLat, element.Id);
            }
          });
        },
        err => {
          console.error("Error : " + err);
        },
        () => {
          console.log('getData completed:');
        }
      );
  }
  call(number: string) 
  {
    console.log("call called");
    if(this.callNumber.isCallSupported)
    {
      console.log("call is supported");
      this.callNumber.callNumber(number, true)
      .then(() => console.log('Dialer Launched!'))
      .catch(() => console.log('Error launching dialer'));
    }
   
  }
  mail(){
    console.log("mail called");
    this.emailComposer.isAvailable().then((available: boolean) =>{
      if(available) {
        console.log("mailcomposer available");
        
      }
     });
     let email = {
      to: 'info@hotelsalden.nl',
      subject: 'Vraag via de mobiele applicatie',
      body: '',
      isHtml: true
    };
    console.log("composer open called");
    // Send a text message using default options
    this.emailComposer.open(email);
     
  } 
  launch(url) {
    this.inAppBrowser.create(url, "_system", "location=true");
  }
  loadNativeMap(long: string, lat: string, name: string) {
    console.log('Map is loading');
    let map: GoogleMap;

    let mapOptions: GoogleMapOptions = {
      camera: {
        target: {
          lat: lat,
          lng: long
        },
        zoom: 18,
        tilt: 30
      }
    };

    map = GoogleMaps.create(name, mapOptions);

    // Wait the MAP_READY before using any methods.
    map.one(GoogleMapsEvent.MAP_READY)
      .then(() => {
        console.log('Map is ready!');

        // Now you can use all methods safely.
        map.addMarker({
          title: name,
          icon: 'blue',
          animation: 'DROP',
          position: {
            lat: Number(lat),
            lng: Number(long)
          }
        })
          .then(marker => {
            marker.on(GoogleMapsEvent.MARKER_CLICK)
              .subscribe(() => {
                alert('clicked');
              });
          });

      });
  }
}


// WEBPACK FOOTER //
// ./src/pages/event/event.ts